import React from 'react';

import './Tile.css';

export const TileDefs = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="defs">
      <defs>
        <linearGradient id="svg-top" x1="0" x2="0" y1="0" y2="1">
          <stop offset="50%" stopColor="var(--tile-bg-shadow-light)" stopOpacity="var(--tile-bg-shadow-light-opacity)"/>
          <stop offset="70%" stopColor="var(--tile-bg-shadow-light)" stopOpacity="0.0"/>
        </linearGradient>
        <linearGradient id="svg-left">
          <stop offset="50%" stopColor="var(--tile-bg-shadow-light)" stopOpacity="var(--tile-bg-shadow-light-opacity)"/>
          <stop offset="70%" stopColor="var(--tile-bg-shadow-light)" stopOpacity="0.0"/>
        </linearGradient>
        <linearGradient id="svg-bottom" x1="0" x2="0" y1="1" y2="0">
          <stop offset="50%" stopColor="var(--tile-bg-shadow-dark)" stopOpacity="var(--tile-bg-shadow-dark-opacity)"/>
          <stop offset="70%" stopColor="var(--tile-bg-shadow-dark)" stopOpacity="0.0"/>
        </linearGradient>
        <linearGradient id="svg-right" x1="1" x2="0" y1="0" y2="0">
          <stop offset="50%" stopColor="var(--tile-bg-shadow-dark)" stopOpacity="var(--tile-bg-shadow-dark-opacity)"/>
          <stop offset="70%" stopColor="var(--tile-bg-shadow-dark)" stopOpacity="0.0"/>
        </linearGradient>

        <linearGradient id="svg-ttop" x1="0" x2="0" y1="0" y2="1">
          <stop offset="20%" stopColor="var(--tile-highlight)" stopOpacity="0.0"/>
          <stop offset="50%" stopColor="var(--tile-highlight)" stopOpacity="var(--tile-highlight-opacity)"/>
          <stop offset="80%" stopColor="var(--tile-highlight)" stopOpacity="var(--tile-highlight-opacity)"/>
          <stop offset="100%" stopColor="var(--tile-highlight)" stopOpacity="0.0"/>
        </linearGradient>
        <linearGradient id="svg-tleft">
          <stop offset="20%" stopColor="var(--tile-highlight)" stopOpacity="0.0"/>
          <stop offset="50%" stopColor="var(--tile-highlight)" stopOpacity="var(--tile-highlight-opacity)"/>
          <stop offset="80%" stopColor="var(--tile-highlight)" stopOpacity="var(--tile-highlight-opacity)"/>
          <stop offset="100%" stopColor="var(--tile-highlight)" stopOpacity="0.0"/>
        </linearGradient>
        <linearGradient id="svg-tbottom" x1="0" x2="0" y1="1" y2="0">
          <stop offset="20%" stopColor="var(--tile-shadow)" stopOpacity="var(--tile-shadow-dark-opacity)"/>
          <stop offset="80%" stopColor="var(--tile-shadow)" stopOpacity="0.0"/>
        </linearGradient>
        <linearGradient id="svg-tright" x1="1" x2="0" y1="0" y2="0">
          <stop offset="20%" stopColor="var(--tile-shadow)" stopOpacity="var(--tile-shadow-dark-opacity)"/>
          <stop offset="80%" stopColor="var(--tile-shadow)" stopOpacity="0.0"/>
        </linearGradient>
      </defs>

      <symbol id="tileBackgroundShadow" width="32" height="32" viewBox="0 0 32 32">
        <path fill="url(#svg-top)" d="M0 0h32l-2 2H2L0 0z"/>
        <path fill="url(#svg-left)" d="M0 0l2 2v28l-2 2z"/>
        <path fill="url(#svg-right)" d="M32 0v32l-2-2V2l2-2z"/>
        <path fill="url(#svg-bottom)" d="M0 32l2-2h28l2 2H0z"/>
      </symbol>

      <symbol id="tileShadow" width="32" height="32" viewBox="0 0 32 32">
        <path fill="url(#svg-ttop)" d="M0 0h32l-3 3H3z"/>
        <path fill="url(#svg-tleft)" d="M0 0l3 3v26l-3 3z"/>
        <path fill="url(#svg-tright)" d="M32 0v32l-3-3V3z"/>
        <path fill="url(#svg-tbottom)" d="M0 32l3-3h26l3 3z"/>
      </symbol>
    </svg>
  );
};

export const TileNone = React.memo(() => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"></svg>
  );
});

export const TileBackground = React.memo(() => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path fill="var(--tile-background-color)" d="M0 0h32v32H0z"/>
      <use href="#tileBackgroundShadow"/>
    </svg>
  );
});

export const TileBackgroundYellow = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="tile-background">
      <path fill="var(--tile-yellow-color)" d="M0 0h32v32H0z"/>
      <use href="#tileBackgroundShadow"/>
      <text x="16" y="14" textAnchor="middle">{props.line1}</text>
      <text x="16" y="25" textAnchor="middle">{props.line2}</text>
    </svg>
  );
});

export const TileBackgroundRed = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="tile-background">
      <path fill="var(--tile-red-color)" d="M0 0h32v32H0z"/>
      <use href="#tileBackgroundShadow"/>
      <text x="16" y="14" textAnchor="middle">{props.line1}</text>
      <text x="16" y="25" textAnchor="middle">{props.line2}</text>
    </svg>
  );
});

export const TileBackgroundBrown = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="tile-background">
      <path fill="var(--tile-brown-color)" d="M0 0h32v32H0z"/>
      <use href="#tileBackgroundShadow"/>
      <text x="16" y="14" textAnchor="middle">{props.line1}</text>
      <text x="16" y="25" textAnchor="middle">{props.line2}</text>
    </svg>
  );
});

export const TileBackgroundGrey = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="tile-background">
      <path fill="var(--tile-gray-color)" d="M0 0h32v32H0z"/>
      <use href="#tileBackgroundShadow"/>
      <text x="16" y="14" textAnchor="middle">{props.line1}</text>
      <text x="16" y="25" textAnchor="middle">{props.line2}</text>
    </svg>
  );
});

export const TileBackgroundStart = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="tile-start">
      <path fill="var(--tile-start-color)" d="M0 0h32v32H0z"/>
      <use href="#tileBackgroundShadow"/>
      <text x="16" y="19" textAnchor="middle" fill="#fff">{props.start}</text>
    </svg>
  );
});

export const Tile = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="tile">
      <path fill="var(--tile-color)" d="M0 0h32v32H0z"/>
      <use href="#tileShadow"/>
      <text className="letter" x="5" y="21">{props.letter}</text>
      <text className="points" x="28" y="28" textAnchor="end">{props.points}</text>
    </svg>
  );
});

export const TileMarked = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="tile">
      <path fill="var(--tile-marked-color)" d="M0 0h32v32H0z"/>
      <use href="#tileShadow"/>
      <text className="letter" x="5" y="21">{props.letter}</text>
      <text className="points" x="28" y="28" textAnchor="end">{props.points}</text>
    </svg>
  );
});

export const TileJoker = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="tile">
      <path fill="var(--tile-color)" d="M0 0h32v32H0z"/>
      <use href="#tileShadow"/>
      <text className="letter" x="5" y="21" opacity="0.58">{props.letter}</text>
    </svg>
  );
});

export const TileJokerMarked = React.memo((props) => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="tile">
      <path fill="var(--tile-marked-color)" d="M0 0h32v32H0z"/>
      <use href="#tileShadow"/>
      <text className="letter" x="5" y="21" opacity="0.58">{props.letter}</text>
    </svg>
  );
});